import {
  getNotification,
  updateNotification,
} from "../../../shared/hooks/useFetchNotifications";
import ApiUrls from "./axr";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import store from "../SharedContextStore/store";
import {
  isSameOrBeforeDate,
  isDiscountApplicableAfterBillingDate,
} from "../../../shared/utils/dateUtils";
import DwLogutil from "./DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../shared/utils/Constants";

export const debounce = (func) => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 300);
  };
};

export function useDebounce(func, wait = 300) {
  let timeout;
  function debounceHandler(...args) {
    const context = this;
    if (!timeout) {
      func.apply(context, args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
    }, wait);
  }
  debounceHandler.cancel = () => {
    if (timeout) clearTimeout(timeout);
  };
  return debounceHandler;
}

export const formatDateWithOffset = (inputDate, offset = 2) => {
  // Parse input date (mm-dd-yyyy)
  const [month, day, year] = inputDate.split("-").map(Number);

  // Create Date object
  const date = new Date(year, month - 1, day);

  // Add offset days
  date.setDate(date.getDate() + offset);

  // Format output as mm/dd/yyyy
  const formattedMonth = String(date.getMonth() + 1).padStart(2, "0");
  const formattedDay = String(date.getDate()).padStart(2, "0");
  const formattedYear = date.getFullYear();

  return `${formattedMonth}/${formattedDay}/${formattedYear}`;
};

export const replaceJSX = (
  text,
  find1,
  replace1,
  find2,
  replace2,
  key = "",
) => {
  const output = text.split(find1).flatMap((item) => [item, replace1]);
  output?.pop();
  if (find2 && replace2 && output[output.length - 1]) {
    const output2 = output[output.length - 1]
      .split(find2)
      .flatMap((item) => [item, replace2]);
    output2?.pop();
    output?.pop();
    return [...output, key === "CCBanner" ? "." : "", ...output2];
  }
  return output;
};

export { isChatEnabled, isOnlyForProd } from "./chat";

export const getAmHost = () => {
  const url = window.location.host;
  switch (url) {
    case "myaccountnextdev2.brightspeed.com":
      return "NEXT_DEV2";
    case "myaccountnextqa.brightspeed.com":
      return "NEXT_QA";
    case "myaccountnextqa2.brightspeed.com":
      return "NEXT_QA2";
    case "myaccountdev2.brightspeed.com":
      return "BAU_DEV2";
    case "myaccountqa1.brightspeed.com":
      return "BAU_QA1";
    case "myaccountqa2.brightspeed.com":
      return "BAU_QA2";
    case "myaccountuat.brightspeed.com":
      return "UAT";
    case "myaccountuat2.brightspeed.com":
      return "UAT2";
    case "myaccount.brightspeed.com":
      return "PROD";
    case "localhost:3000":
      return "BAU_QA2";
    //    return "PROD";
  }
};

export const encryptText = (text, privateKey) => {
  try {
    if (window?.pidCryptUtil && window?.pidCrypt) {
      var key = window?.pidCryptUtil.decodeBase64(privateKey);
      var rsa = new window.pidCrypt.RSA();
      //ASN1 parsing
      var asn = window?.pidCrypt.ASN1.decode(
        window?.pidCryptUtil.toByteArray(key),
      );
      var tree = asn.toHexTree();
      //setting the public key for encryption with retrieved ASN.1 tree
      rsa.setPublicKeyFromASN(tree);
      // Base64 encode and encrypt the string
      var crypted = rsa.encrypt(text);
      return window?.pidCryptUtil.encodeBase64(
        window?.pidCryptUtil.convertFromHex(crypted),
      );
    }
  } catch (error) {
    return error;
  }
};

export const onEnterKeyPress = (event, callBackFun) => {
  if (event.key === "Enter") {
    event?.preventDefault();
    if (callBackFun && typeof callBackFun === "function") {
      callBackFun(event);
    }
  }
};

export const toggleOneTrust = () => {
  if (window?.OneTrust) {
    window?.OneTrust?.ToggleInfoDisplay();
  }
};
export const cookieSetting = () => {
  window?.showConsentBanner?.();
};
export const calculateRemainingBalance = (paymentHistoryForPA) => {
  const remainingBalance =
    paymentHistoryForPA?.paymentHistory?.treatment?.[0]?.installment?.reduce(
      (remainingBalance, item) => {
        if (item.status !== "Paid") {
          return remainingBalance + item.amount;
        }
        return remainingBalance;
      },
      0,
    );

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(remainingBalance);
};
export const formatDueDate = (dueDate) => {
  if (!dueDate) return "";

  const formattedDate = new Date(dueDate?.replace(/-/g, "/"));
  const month = formattedDate?.getMonth() + 1; // 0-indexed, add 1
  const day = formattedDate?.getDate(); // Automatically single digit if < 10
  const year = formattedDate?.getFullYear();

  return `${month}/${day}/${year}`;
};

export const formatSuspendEndDate = (dueDate, isdisplay = true) => {
  if (!dueDate) return "";

  const formattedDate = new Date(dueDate?.replace(/-/g, "/"));
  const TempMonth = formattedDate?.getMonth() + 1; // 0-indexed, add 1
  const tempday = formattedDate?.getDate(); // Automatically single digit if < 10
  const year = formattedDate?.getFullYear();
  const day = tempday < 10 ? `0${tempday}` : `${tempday}`;
  const month = TempMonth < 10 ? `0${TempMonth}` : `${TempMonth}`;

  return isdisplay ? `${month}/${day}/${year}` : `${year}-${month}-${day}`;
};

export const getDaysRemaining = (expDate) => {
  if (!expDate) return null;

  const expiry =
    expDate instanceof Date
      ? new Date(expDate)
      : new Date(String(expDate).replace(/-/g, "/"));
  if (isNaN(expiry.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  expiry.setHours(0, 0, 0, 0);

  const msPerDay = 24 * 60 * 60 * 1000;
  const days = Math.round((expiry - today) / msPerDay);
  return Math.max(days, 0);
};

export const addOneMonth = (dueDate) => {
  if (!dueDate) return "";
  const tempFormatDate = formatSuspendEndDate(dueDate, false);
  // Split input into year, month, day
  const [year, month, day] = tempFormatDate
    .split("-")
    .map((val) => parseInt(val, 10));
  const parsedDate = new Date(year, month - 1, day);

  // Store the original day to check if it overflows
  const originalDay = parsedDate.getDate();

  // Add one month to the current date
  parsedDate.setMonth(parsedDate.getMonth() + 1);

  // Check if the new month has fewer days than the original month
  if (parsedDate.getDate() < originalDay) {
    // Set to the last valid day of the new month
    parsedDate.setDate(0);
  }

  // Get the updated year, month, and day
  const updatedYear = parsedDate.getFullYear();
  const updatedMonth = parsedDate.getMonth() + 1; // Month is 0-indexed
  const updatedDay = parsedDate.getDate();

  // Format to ensure two digits for the month and day
  const formattedMonth =
    updatedMonth < 10 ? `0${updatedMonth}` : `${updatedMonth}`;
  const formattedDay = updatedDay < 10 ? `0${updatedDay}` : `${updatedDay}`;

  // Return in the format YYYY-MM-DD
  return `${updatedYear}-${formattedMonth}-${formattedDay}`;
};

export const phoneNumberValidation = (e) => {
  if (e.keyCode >= 48 && e.keyCode <= 57) {
    e.target.value = e?.target?.value
      ?.replace(/^(\d{3})(\d{3})(\d+)$/, "($1) $2-$3")
      .substr(0, 13);
  } else if (e.keyCode === 9) {
    return true;
  } else {
    if (e.keyCode == 8 || e.keyCode == 46) {
      return false;
    } else {
      e.preventDefault();
      return false;
    }
  }
};

export const phoneNumberValidationMask = (e) => {
  if (!/[0-9 ]/.test(e?.key)) {
    e?.preventDefault();
    return false;
  }
  if (e?.target?.value?.length < 14) {
    e.target.value = e?.target?.value
      ?.replace(/^(\d{3})(\d{3})(\d+)$/, "($1) $2-$3")
      .substr(0, 13);
  } else if (e?.target?.value?.length === 14) {
    return true;
  } else {
    e?.preventDefault();
    return false;
  }
};

export const creditCardExpiryAutoFormat = (e) => {
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
  if (/^[a-zA-Z]$/.test(e.key) && !allowedKeys.includes(e.key)) {
    e.preventDefault();
    return false;
  }
  if (allowedKeys.includes(e.key)) {
    return true;
  } else {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
    if (e.target.value.length < 7) {
      e.target.value = e.target.value
        .replace(
          /^([1-9]\/|[2-9])$/g,
          "0$1/", // To handle 3/ > 03/
        )
        .replace(
          /^(0[1-9]{1}|1[0-2]{1})$/g,
          "$1/", // 11 > 11/
        )
        .replace(
          /^([0-1]{1})([3-9]{1})$/g,
          "0$1/$2", // 13 > 01/3
        )
        .replace(
          /^(\d)\/(\d\d)$/g,
          "0$1/$2", // To handle 1/11 > 01/11
        )
        .replace(
          /^(0?[1-9]{1}|1[0-2]{1})([0-9]{2})$/g,
          "$1/$2", // 141 > 01/41
        )
        .replace(
          /^(([0]{1,})\/|[0]{1,})$/g,
          "0", // To handle 0/ > 0 and 00 > 0
        )
        .replace(
          /[^\d\/]|^[\/]{0,}$/g,
          "", // To allow only numbers and /
        )
        .replace(
          /\/\//g,
          "/", // Prevent entering more than 1 /
        );
      return true;
    } else if (e.target.value.length === 7) {
      return true;
    } else {
      e.preventDefault();
      return false;
    }
  }
};

export const getCaptchaToken = async (action = "login") => {
  return new Promise((resolve, reject) => {
    window?.grecaptcha?.enterprise.ready(async () => {
      try {
        const token = await window?.grecaptcha?.enterprise?.execute(
          process.env.REACT_APP_RECAPTCHA_KEY,
          {
            action: action,
          },
        );
        if (token) {
          resolve(token);
        } else {
          reject(Error("something went wrong while genererate captcha token"));
        }
      } catch (error) {
        return reject(error);
      }
    });
  });
};

export const repairAppointmentSortedData = (e) => {
  return e.reduce((a, b) => (a.date > b.date ? a : b));
};

export const getFormattedDate = (value) => {
  let date = new Date(value);
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

export const setNotificationStatusTime = (value, id, type) => {
  let data = value?.notifications?.filter(
    (item) => item.notificationId === id + type,
  );
  return data?.length && data[0]?.createdDate;
};
export const getServiceAddressId = (userAddress) => {
  let tempAddr = "";
  if (userAddress) {
    let { addressId } = userAddress?.find((item) => {
      if (item?.addressType && item?.addressType === "ServiceAddress") {
        return item;
      }
    });
    tempAddr = addressId;
  }
  return tempAddr;
};

export const getServiceAddressFromUser = (user) => {
  return user?.addresses?.find(
    (addr) => addr?.addressType === "ServiceAddress",
  );
};

/* Speed pay encryption */
export const encryptNativeSpeedPay = async (text, publicKey) => {
  const encoder = new TextEncoder();
  try {
    // base64 decode the string to get the binary data
    const binaryDerString = window.atob(publicKey);

    // convert from a binary string to an ArrayBuffer
    const binaryDer = str2ab(binaryDerString);
    const cryptoPublicKey = await window.crypto.subtle.importKey(
      "spki",
      binaryDer,
      { name: "RSA-OAEP", hash: "SHA-256" },
      true,
      ["encrypt"],
    );
    const crypted = await window.crypto.subtle.encrypt(
      cryptoPublicKey.algorithm,
      cryptoPublicKey,
      encoder.encode(text),
    );
    return window.btoa(
      String.fromCharCode.apply(null, new Uint8Array(crypted)),
    );
  } catch (error) {
    return await Promise.resolve(text);
  }
};

function str2ab(str) {
  const buf = new ArrayBuffer(str.length);
  const bufView = new Uint8Array(buf);
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

export const getDateAndTimeForCTLRescheduleAppoitmentAPI = (date, time) => {
  if (!date || !time) {
    return null;
  }
  return format(new Date(`${date} ${time}`), "yyyy-MM-dd'T'HH:mm:ss");
};

export const getCardNumberWithMasking = (creditCardNumber) => {
  return (
    (creditCardNumber &&
      creditCardNumber?.length > 4 &&
      "****" +
        creditCardNumber?.toString()?.substr(creditCardNumber?.length - 4)) ||
    creditCardNumber
  );
};

export const getBanWithMasking = (ban) => {
  return (
    (ban &&
      ban?.length > 4 &&
      "****" + ban?.toString()?.substr(ban?.length - 4)) ||
    ban
  );
};

export { chatClick, endChat, wifiExtenderChatClick } from "./chat";

export function getFormatedStringFromDays(numberOfDays) {
  if (Number.isInteger(numberOfDays)) {
    let years = Math.floor(numberOfDays / 365);
    let months = Math.floor((numberOfDays % 365) / 30);
    let days = Math.floor((numberOfDays % 365) % 30);

    let yearsDisplay =
      years > 0 ? years + (years == 1 ? " year, " : " years, ") : "";
    let monthsDisplay =
      months > 0 ? months + (months == 1 ? " month, " : " months, ") : "";
    let daysDisplay = days > 0 ? days + (days == 1 ? " day" : " days") : "";
    return yearsDisplay + monthsDisplay + daysDisplay;
  } else {
    return "not a number";
  }
}

export function isNegative(value) {
  // true if negative string
  if (typeof value === "string") {
    return value.indexOf("-") > -1;
  }

  if (typeof value === "number") {
    return Math.sign(value) === -1;
  }
  return;
}

export function valueExtract(value) {
  if (!value) return {};

  if (typeof value === "number") {
    if (isNegative(value)) {
      return {
        value: Math.abs(value),
        sign: "-",
      };
    }
    return {
      value,
      sign: "",
    };
  }
  if (typeof value === "string") {
    if (isNegative(value)) {
      return {
        value: value?.replace(/[-$]/g, ""),
        sign: "-",
      };
    }
    return {
      value: value?.replace(/[$]/g, ""),
      sign: "",
    };
  }

  return {
    // if input is not a String or Number
    value: "0.00",
    sign: "",
  };
}

export function fixValToDecimal(value) {
  if (isNaN(value)) return "0.00";
  return parseFloat(value)?.toFixed(2);
}

export function renderCurrency(inputValue, inputCurrency = "$") {
  if (!inputValue) return "";

  const { value, sign } = valueExtract(inputValue);
  const floatValue = fixValToDecimal(value);
  return `${sign}${inputCurrency}${floatValue}`;
}

export function useHandleShopExpApiError() {
  const navigate = useNavigate();
  return () => {
    const errorPage = "/error";
    navigate(errorPage);
  };
}

/**
 * Detects a Redux Toolkit createAsyncThunk ConditionError, which is thrown
 * (when calling `.unwrap()`) if the thunk's `condition` callback returned false
 * — typically because an identical request is already in flight. This is NOT
 * an API failure and should not trigger an error-page redirect.
 */
export function isThunkConditionError(error) {
  return error?.name === "ConditionError";
}

export function compareString(str1, str2) {
  return str1?.toLowerCase().includes(str2?.toLowerCase());
}
export function extractAddonByName(arr, name) {
  let item = { ...arr?.find((item) => compareString(item.productName, name)) };
  if (item && item && Object.keys(item).length) {
    item.price = item?.childProducts?.[0]?.priceResult?.[0]?.productCharge;
  }
  return item;
}
export function extractAddonByNameForPostpaid(arr, name) {
  let item = { ...arr?.find((item) => compareString(item.productName, name)) };
  if (item && item && Object.keys(item).length) {
    item.price = item?.priceResult?.[0]?.productCharge;
  }
  return item;
}

export function compareCartItemWithExisting(
  existing,
  itemsAddedOrRemoved,
  cartResponse = [],
  coming = "",
) {
  // Extract product names from existing plans for easy lookup

  const existingProducts = new Set(
    existing.additionalPlans.map((plan) => plan.productName.toLowerCase()),
  );

  // Flag to track if any issues were found

  let foundIssue = false;

  // Iterate through itemsAddedOrRemoved to check for differences

  for (let item of itemsAddedOrRemoved) {
    const itemName = item.name.toLowerCase();

    // If trying to add a product that already exists in existing products

    if (item.action === "add" && existingProducts.has(itemName)) {
      foundIssue = true; // Product already exists
    }

    // If trying to remove a product that exists in existing products

    if (item.action === "remove" && existingProducts.has(itemName)) {
      foundIssue = true; // Product exists and is being removed
    }

    // If trying to add a product that does not exist in existing products

    if (item.action === "add" && !existingProducts.has(itemName)) {
      foundIssue = true; // Product does not exist and is being added
    }

    // If trying to remove a product that does not exist in existing products

    if (item.action === "remove" && !existingProducts.has(itemName)) {
      foundIssue = true; // Product does not exist and is being removed
    }
  }

  // Check for issues in cartResponse
  if (cartResponse.length === 0) {
    return foundIssue;
  }
  const cartProducts = new Set(
    cartResponse.map((item) => item.productName.toLowerCase()),
  );

  for (let cartItem of cartResponse) {
    const cartItemName = cartItem.productName.toLowerCase();

    const cartItemType = cartItem.action; // Assuming action in cartResponse is either "add" or "remove"

    // If trying to add a product that is not in the existing products

    if (cartItemType !== "remove" && !existingProducts.has(cartItemName)) {
      foundIssue = true; // Product being added from cart does not exist in existing
    }

    // If trying to remove a product that exists in existing products

    if (cartItemType === "remove" && existingProducts.has(cartItemName)) {
      foundIssue = true; // Product being removed from cart exists in existing
    }

    // If trying to add a product from cart that already exists in existing products

    if (cartItemType !== "remove" && existingProducts.has(cartItemName)) {
      foundIssue = false; // Product being added from cart already exists in existing
    }

    // If trying to remove a product from cart that does not exist in existing products

    if (cartItemType === "remove" && !existingProducts.has(cartItemName)) {
      foundIssue = true; // Product being removed from cart does not exist in existing
    }
  }
  return foundIssue;
}

export function processCartAndCurrentPlan(cart, currentPlan) {
  // Initialize the result objects
  let current = [];
  let newCart = [];
  // Create a set of current plan product names (including additional products)
  const currentPlanNames = new Set(
    currentPlan.map((plan) => plan.additionalPlanName),
  );
  // Order priority for product names

  const productOrder = [
    "WiFi Extender",
    "Brightspeed Total Home Tech Support",
    "protection",
  ];

  // Helper function to order products according to productOrder array
  function orderProducts(products) {
    return products.sort(
      (a, b) =>
        productOrder.indexOf(a.productName) -
        productOrder.indexOf(b.productName),
    );
  }

  // Loop through the cart items

  cart.forEach((item) => {
    const productName = item.productName;
    const itemActionType = item.itemActionType || ""; // Default to empty string if no action is provided

    // If the product is marked for removal

    if (itemActionType === "remove") {
      // If it's in the additional plan, mark it with "show" in current and "no show" in new

      if (currentPlanNames.has(productName)) {
        current.push({
          productName: productName,
          action: "show", // Mark as "show" in current
        });

        newCart.push({
          productName: productName,
          action: "no show", // Mark as "no show" in new
        });
      }
    } else {
      // If the product is not marked for removal
      if (currentPlanNames.has(productName)) {
        // If the product is in the current plan, mark itas "no show" in current and "show" in new
        current.push({
          productName: productName,
          action: "show",
        });
        newCart.push({
          productName: productName,
          action: "show", // Mark as "show" in new
        });
      } else {
        // If the product is not in the current plan, mark it as "show" in current and new
        current.push({
          productName: productName,
          action: "no show", // Mark as "show" in current
        });
        newCart.push({
          productName: productName,
          action: "show", // Mark as "show" in new as well
        });
      }
    }
  });

  // Sort products based on the defined order
  current = orderProducts(current);
  newCart = orderProducts(newCart);

  return {
    current,
    newCart,
  };
}

export const mergeAdditionalPlans = (plans) => {
  const map = new Map();

  for (const plan of plans) {
    const key = plan.additionalPlanName;

    if (!map.has(key)) {
      map.set(key, { ...plan, quantity: 1 });
    } else {
      const existing = map.get(key);

      existing.quantity += 1; // count occurrences, ignore input quantity
      existing.additionalPlanPrice += !compareString(
        plan.additionalPlanName,
        "whole",
      )
        ? plan?.additionalPlanPrice
        : 0;
      existing.planID = [existing.productRatePlanId, plan?.productRatePlanId];
    }
  }

  return Array.from(map.values());
};

export const fixWIFICountWithGrandfatherOld = (data, user) => {
  let _data = { ...data };
  let isGrandFather = user?.isGrandFather;

  let DiscountOnWifi = null;
  let _postpaidwifiDiscount = null;
  if (_data?.discountPlans && Array.isArray(_data?.discountPlans)) {
    DiscountOnWifi = _data?.discountPlans.find((item) =>
      compareString(item.productName, "Extender"),
    );
  }

  if (_data?.standardPlans && Array.isArray(_data?.standardPlans)) {
    _postpaidwifiDiscount = _data?.standardPlans.find((item) =>
      compareString(item.productName, "extender"),
    );
    if (_postpaidwifiDiscount?.activetoDiscountsSet) {
      _postpaidwifiDiscount = _postpaidwifiDiscount?.activetoDiscountsSet[0];
    }
  }

  // merge same typeof addon show it single
  if (_data?.additionalPlans && Array.isArray(_data?.additionalPlans)) {
    _data.additionalPlans = _data.additionalPlans.map((item, i, array) => {
      if (
        array[i + 1] &&
        item?.additionalPlanName === array[i + 1]?.additionalPlanName
      ) {
        item.allZouraId = [
          item.productRatePlanId,
          array[i + 1].productRatePlanId,
        ];
      }
      return item;
    });

    _data.additionalPlans = mergeAdditionalPlans(_data.additionalPlans);
  }

  if (_data?.standardPlans && Array.isArray(_data?.standardPlans)) {
    _data.standardPlans = _data?.standardPlans?.map((item) => {
      item.planPrice = fixValToDecimal(item.planPrice);
      return item;
    });
  }

  // adding count in wifi extender name
  if (_data?.additionalPlans && Array.isArray(_data?.additionalPlans)) {
    _data.additionalPlans = _data?.additionalPlans?.map((item) => {
      if (compareString(item?.additionalPlanName, "extender")) {
        item.additionalPlanName =
          item.additionalPlanName + " - " + item.quantity + " count";
        item.ratePlanName =
          item.ratePlanName + " - " + item.quantity + " count";
        item.productName = item.productName + " - " + item.quantity + " count";

        if (DiscountOnWifi) {
          item.discount = DiscountOnWifi?.discountAmount
            ? DiscountOnWifi?.discountAmount?.toFixed(2)
            : 0;
          item.discountName = DiscountOnWifi?.ratePlanName;
          item.validity = new Date(
            DiscountOnWifi?.effectiveEndDate,
          )?.toLocaleString("en-US", {
            month: "numeric", // Numeric month without leading zero
            day: "numeric", // Numeric day without leading zero
            year: "numeric", // Full year
          });
          // item.additionalPlanPrice=item?.additionalPlanPrice-DiscountOnWifi?.discountAmount
        }

        if (_postpaidwifiDiscount) {
          item.discount = _postpaidwifiDiscount?.Discvalue
            ? _postpaidwifiDiscount?.Discvalue.toFixed(2)
            : 0;
          item.discountName = _postpaidwifiDiscount?.Discdescription;
          item.validity = new Date(
            _postpaidwifiDiscount?.Discenddate,
          ).toLocaleString("en-US", {
            month: "numeric", // Numeric month without leading zero
            day: "numeric", // Numeric day without leading zero
            year: "numeric", // Full year
          });

          // item.additionalPlanPrice=item?.additionalPlanPrice-DiscountOnWifi?.discountAmount
        }
      }
      return item;
    });
  }

  // removing thic from additional plan if there
  if (
    isGrandFather &&
    _data?.additionalPlans &&
    Array.isArray(_data?.additionalPlans)
  ) {
    _data.additionalPlans = _data?.additionalPlans?.filter((item) => {
      return (
        !compareString(item?.ratePlanName, "protection") ||
        !compareString(item?.ratePlanName, "controls")
      );
    });
    //   _data.additionalPlans = _data.additionalPlans.filter((item)=>{
    //     return !compareString(item.ratePlanName,"wifi")
    // })
  }

  // sorting data
  _data?.additionalPlans?.sort((a, b) => {
    const order = [
      "fiber",
      "mbps",
      "voice",
      "extender",
      "protection",
      "internet controls",
      "tech",
    ];
    const aIndex = order.findIndex((key) =>
      a?.ratePlanName?.toLowerCase().includes(key),
    );
    const bIndex = order.findIndex((key) =>
      b?.ratePlanName?.toLowerCase().includes(key),
    );
    return (
      (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex)
    );
  });

  return _data;
};

export const fixWIFICountWithGrandfather = (data, user) => {
  let hasDisc = [];

  const paymentDetails =
    store.getState()?.nextPaymentDetails?.nextPaymentDetails;
  let upcomingDates;
  if (paymentDetails?.dueDate) {
    const nexDate1 = new Date(paymentDetails?.dueDate?.replace(/-/g, "/"));
    const nexPaymentMonth = nexDate1?.toLocaleString("en-us", {
      timeZone: "UTC",
      month: "2-digit",
    });
    const nextPaymentDate = nexDate1?.toLocaleString("en-us", {
      timeZone: "UTC",
      day: "2-digit",
    });
    const nextPaymentYear = nexDate1?.getFullYear();
    let nextDate = `${nextPaymentYear}-${nexPaymentMonth}-${nextPaymentDate}`;

    const tempUpcomingDates = {
      upcomingStartDueDate: moment(`${nextDate}`, "YYYY-MM-DD"),
      upcomingEndDueDate: moment(`${nextDate}`)
        .add(1, "months")
        .format("YYYY-MM-DD"),
      /* moment(`${nextPaymentYear}-${nexPaymentMonth}-${nextPaymentDate}`, "YYYY-MM-DD")?.add(1,"M") */
    };
    upcomingDates = tempUpcomingDates;
  }
  let _data = { ...data };
  let isGrandFather = user?.isGrandFather;
  let userType = user?.data?.billingType || "";

  let DiscountOnWifi = null;
  let _postpaidwifiDiscount = null;

  if (_data?.discountPlans && Array.isArray(_data?.discountPlans)) {
    DiscountOnWifi = _data?.discountPlans?.filter((item) => {
      return (
        compareString(item?.productName, "extender") ||
        compareString(item?.productName, "whole") ||
        compareString(item?.productName, "tech support") ||
        compareString(item?.productName, "protection")
      );
    });
  }

  // CHANGE START: pick first non‑expired extender discount across ALL standardPlans
  if (_data?.standardPlans && Array.isArray(_data?.standardPlans)) {
    const toDate = (mmddyyyy) => {
      const [mm, dd, yyyy] = (mmddyyyy || "").split(".");
      return new Date(Number(yyyy), Number(mm) - 1, Number(dd));
    };

    const isNonExpiredDisc = (disc) =>
      !!disc?.Discenddate && toDate(disc.Discenddate) >= new Date();

    const extenderPlans = _data.standardPlans.filter(
      (item) =>
        compareString(item.productName, "whole") ||
        compareString(item.productName, "extender") ||
        compareString(item.productName, "protection") ||
        compareString(item.productName, "tech support") ||
        compareString(item?.additionalPlanName, "whole") ||
        compareString(item?.additionalPlanName, "protection") ||
        compareString(item?.additionalPlanName, "extender"),
    );

    const allExtenderDiscounts = extenderPlans.flatMap(
      (plan) => plan.activetoDiscountsSet || [],
    );

    _postpaidwifiDiscount =
      allExtenderDiscounts.filter(isNonExpiredDisc) || null;
  }
  // CHANGE END

  // merge same typeof addon show it single
  if (
    _data?.additionalPlans &&
    Array.isArray(_data?.additionalPlans) &&
    userType?.toLowerCase() !== "prepaid"
  ) {
    let zouraID = [];
    let skus = [];

    _data.additionalPlans.forEach((item) => {
      if (item?.additionalPlanName?.toLowerCase() === "whole home wifi") {
        zouraID.push({
          sku: item.productSku,
          ratePlanId: item.productRatePlanId,
        });
      }
    });

    _data.additionalPlans = _data.additionalPlans.map((item) => {
      if (item?.additionalPlanName?.toLowerCase() === "whole home wifi") {
        return {
          ...item,
          zouraID,
        };
      }
      return item;
    });

    _data.additionalPlans = mergeAdditionalPlans(_data?.additionalPlans);
  }

  if (Array.isArray(_data?.standardPlans)) {
    _data.standardPlans = _data.standardPlans.map((item) => {
      return {
        ...item,
        planPrice: fixValToDecimal(item?.planPrice),
      };
    });
  }
  // adding count in wifi extender name
  if (_data?.additionalPlans && Array.isArray(_data?.additionalPlans)) {
    _data.additionalPlans = _data.additionalPlans.map((item) => {
      if (
        compareString(item?.additionalPlanName, "extender") &&
        !compareString(item?.additionalPlanName, "additional wifi extender")
      ) {
        item.additionalPlanName =
          item?.additionalPlanName + " - " + item?.quantity + " count";
        item.ratePlanName =
          item?.ratePlanName + " - " + item?.quantity + " count";
        item.productName =
          item?.productName + " - " + item?.quantity + " count";

        // if (DiscountOnWifi) {
        //   item.discount = DiscountOnWifi?.length > 0
        //     ? DiscountOnWifi.discountAmount.toFixed(2)
        //     : 0;
        //   item.discountName = DiscountOnWifi?.ratePlanName;
        //   item.validity = new Date(
        //     DiscountOnWifi?.effectiveEndDate
        //   ).toLocaleString("en-US", {
        //     month: "numeric",
        //     day: "numeric",
        //     year: "numeric",
        //   });
        // }

        // const getDateInFormat = (date, strFormat = 'YYYY-MM-DD', preFormat = "MM-DD-YYYY") => {
        //   return moment(date, preFormat).format(strFormat)
        // }

        DiscountOnWifi && applyCombinedDiscount(item, DiscountOnWifi);

        function applyCombinedDiscount(item, discountOnWifi) {
          const discounts = Array.isArray(discountOnWifi)
            ? discountOnWifi
            : discountOnWifi
              ? [discountOnWifi]
              : [];

          if (discounts.length === 0) {
            item.discount = 0;
            item.discountName = null;
            item.validity = null;
            return;
          }

          // Filter discounts that match the max amount
          const bestDiscounts = discounts?.filter(
            (d) =>
              !d?.planName
                ?.toLowerCase()
                .includes("first month free-wifi extender"),
          );
          // Sum up their discount amounts
          // For name & validity, you might choose how to represent — e.g. join names
          const names = bestDiscounts
            .map((d) => d.ratePlanName || d.planName)
            .filter(
              (name, index, self) => name && self.indexOf(name) === index,
            ); // unique names

          // As an example: for validity choose the latest end date among those
          const latestDiscount = bestDiscounts?.filter((dis) => {
            let discountEffEndtDate =
              dis?.effectiveEndDate &&
              moment(dis?.effectiveEndDate, "YYYY-MM-DD");
            const result = discountEffEndtDate?.isSameOrBeforeDate(
              upcomingDates?.upcomingStartDueDate,
            );
            return !result && dis;
          });
          const totalDiscount = latestDiscount.reduce(
            (sum, d) => sum + (d?.discountAmount ?? 0),
            0,
          );
          item.discount = totalDiscount?.toFixed(2);
          item.allDiscount = latestDiscount;
          item.discountName = latestDiscount
            ?.map((d) => d.ratePlanName || d.planName)
            .filter(
              (name, index, self) => name && self.indexOf(name) === index,
            ); // unique names
          item.validity = latestDiscount?.effectiveEndDate
            ? latestDiscount?.effectiveEndDate?.toLocaleString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric",
              })
            : null;
        }

        // if (_postpaidwifiDiscount) {
        //   item.discount = _postpaidwifiDiscount?.Discvalue
        //     ? _postpaidwifiDiscount.Discvalue.toFixed(2)
        //     : 0;
        //   item.discountName = _postpaidwifiDiscount?.Discdescription;
        //   item.validity = new Date(
        //     _postpaidwifiDiscount?.Discenddate
        //   ).toLocaleString("en-US", {
        //     month: "numeric",
        //     day: "numeric",
        //     year: "numeric",
        //   });
        // }
        if (_postpaidwifiDiscount?.length > 0) {
          const discountNew = Array.isArray(_postpaidwifiDiscount)
            ? _postpaidwifiDiscount
            : _postpaidwifiDiscount
              ? [_postpaidwifiDiscount]
              : [];
          // Filter discounts that match the max amount
          const bestDiscountsNew = discountNew?.filter((dis) => {
            // let dueDate = paymentDetails?.dueDate && moment(paymentDetails?.dueDate, "YYYY-MM-DD");
            // let newDate = getDateInFormat(dis?.Discenddate, "MM/DD/YYYY")
            // let discountEffEndtDate = dis?.Discenddate && moment(dis?.Discenddate, "YYYY-MM-DD");
            const nexDate1 = new Date(dis?.Discenddate?.replace(/-/g, "/"));
            const nexPaymentMonth = nexDate1?.toLocaleString("en-us", {
              month: "2-digit",
            });
            const nextPaymentDate = nexDate1?.toLocaleString("en-us", {
              day: "2-digit",
            });
            const nextPaymentYear = nexDate1?.getFullYear();
            let nextDueDate = `${nextPaymentYear}-${nexPaymentMonth}-${nextPaymentDate}`;
            const nexDate2 = new Date(dis?.Discfromdate?.replace(/-/g, "/"));
            const nexPaymentMonth1 = nexDate2?.toLocaleString("en-us", {
              month: "2-digit",
            });
            const nextPaymentDate1 = nexDate2?.toLocaleString("en-us", {
              day: "2-digit",
            });
            const nextPaymentYear1 = nexDate2?.getFullYear();
            let nextDueDate2 = `${nextPaymentYear1}-${nexPaymentMonth1}-${nextPaymentDate1}`;
            let loyaltyResult = false;
            // const result = isSameOrBeforeDate(nextDueDate, (upcomingDates?.upcomingStartDueDate));
            //  loyaltyResult= dis?.Discfrequency?.toUpperCase() === "RECURRING" && isDiscountApplicableAfterBillingDate(nextDueDate2, upcomingDates?.upcomingStartDueDate);
            // return (result && !loyaltyResult) && dis
            const result = isSameOrBeforeDate(
              nextDueDate,
              upcomingDates?.upcomingStartDueDate,
            );
            loyaltyResult =
              dis?.Discfrequency?.toUpperCase() === "RECURRING" &&
              isDiscountApplicableAfterBillingDate(
                nextDueDate2,
                upcomingDates?.upcomingStartDueDate,
              );
            return !result && !loyaltyResult && dis;
          });
          // Sum up their discount amounts
          const totalDiscountNew = bestDiscountsNew.reduce(
            (sum, d) => sum + (d.Discvalue ?? 0),
            0,
          );
          const discounts = bestDiscountsNew?.map((disc) => ({
            discount: disc?.Discvalue ? disc.Discvalue?.toFixed(2) : 0,
            discountName: disc?.Discdescription,
            Discfrequency: disc?.Discfrequency,
            validity: new Date(disc?.Discenddate).toLocaleString("en-US", {
              month: "numeric",
              day: "numeric",
              year: "numeric",
            }),
          }));
          item.discount = discounts;
          item.totalDiscount = totalDiscountNew?.toFixed(2);
        }
      }

      return item;
    });
  }
  // adding extenders for Whole Home Wifi
  const whwFlag = process.env.REACT_APP_WHW_ENABLED === "true";
  if (
    _data?.additionalPlans &&
    Array.isArray(_data?.additionalPlans) &&
    whwFlag
  ) {
    _data.additionalPlans = _data.additionalPlans?.reduce((acc, item) => {
      const found = acc?.find((obj) => {
        if (
          compareString(item.additionalPlanName, "Whole Home WiFi") ||
          compareString(item.additionalPlanName, "WHWiFi")
        ) {
          return (
            compareString(obj.additionalPlanName, "Whole Home WiFi") ||
            compareString(obj.additionalPlanName, "WHWiFi")
          );
        } else {
          return obj.additionalPlanName === item.additionalPlanName;
        }
      });

      if (found) {
        found.quantity++;
      } else {
        acc.push({ ...item, quantity: item.quantity ? item.quantity : 1 });
      }
      return acc;
    }, []);
    let additionalExtenderDiscount = null;
    _data.additionalPlans = _data.additionalPlans.map((item) => {
      if (
        compareString(item?.additionalPlanName, "whole") ||
        compareString(item?.additionalPlanName, "whole") ||
        compareString(item?.additionalPlanName, "WHWiFi")
      ) {
        if (
          compareString(item?.productRatePlanId, "WH2") ||
          compareString(item?.ratePlanLabel, "package 2") ||
          compareString(item?.productRatePlanId, "package 2")
        ) {
          item.quantity = 2;
        }

        if (compareString(item?.productRatePlanId, "WH3")) {
          item.quantity = 3;
        }

        item.additionalPlanName = item?.additionalPlanName;
        item.orignalRatePlanName = item?.ratePlanName;

        item.ratePlanName = compareString(item?.ratePlanName, "WHWiFi")
          ? item?.additionalPlanName
          : item?.ratePlanName;
        item.productName = compareString(item?.ratePlanName, "WHWiFi")
          ? item?.additionalPlanName
          : item?.ratePlanName;

        // if (item?.quantity === 1) {
        //   item.additionalPlanName = item?.additionalPlanName;
        //   item.productName = item?.ratePlanName;
        // } else {
        //   item.additionalPlanName =
        //     item?.additionalPlanName + " - " + item?.quantity + " extenders";
        //   item.productName =
        //     item?.ratePlanName + " - " + item?.quantity + " extenders";
        // }
        item.ratePlanName = item?.ratePlanName;
        DiscountOnWifi && applyCombinedDiscount(item, DiscountOnWifi);
        function applyCombinedDiscount(item, discountOnWifi) {
          const discounts = Array.isArray(discountOnWifi)
            ? discountOnWifi
            : discountOnWifi
              ? [discountOnWifi]
              : [];

          if (discounts.length === 0) {
            item.discount = 0;
            item.discountName = null;
            item.validity = null;
            return;
          }

          // Filter discounts that match the max amount
          const bestDiscounts = discounts?.filter(
            (d) =>
              !d?.planName
                ?.toLowerCase()
                .includes("first month free-wifi extender"),
          );
          // Sum up their discount amounts
          // For name & validity, you might choose how to represent — e.g. join names
          const names = bestDiscounts
            .map((d) => d.ratePlanName || d.planName)
            .filter(
              (name, index, self) => name && self.indexOf(name) === index,
            ); // unique names

          // As an example: for validity choose the latest end date among those
          const latestDiscount = bestDiscounts?.filter((dis) => {
            let discountEffEndtDate =
              dis?.effectiveEndDate &&
              moment(dis?.effectiveEndDate, "YYYY-MM-DD");
            const result = discountEffEndtDate?.isSameOrBefore(
              upcomingDates?.upcomingStartDueDate,
            );
            return !result && dis;
          });

          const totalDiscount = latestDiscount.reduce(
            (sum, d) => sum + (d?.discountAmount ?? 0),
            0,
          );
          item.discount = totalDiscount?.toFixed(2);
          item.allDiscount = latestDiscount;
          item.discountName = latestDiscount
            ?.map((d) => d.ratePlanName || d.planName)
            .filter(
              (name, index, self) => name && self.indexOf(name) === index,
            ); // unique names
          item.validity = latestDiscount?.effectiveEndDate
            ? latestDiscount?.effectiveEndDate?.toLocaleString("en-US", {
                month: "numeric",
                day: "numeric",
                year: "numeric",
              })
            : null;
        }
        if (_postpaidwifiDiscount?.length > 0) {
          const discountNew = Array.isArray(_postpaidwifiDiscount)
            ? _postpaidwifiDiscount
            : _postpaidwifiDiscount
              ? [_postpaidwifiDiscount]
              : [];

          // Filter discounts that match the max amount
          const bestDiscountsNew = discountNew?.filter((dis) => {
            const nexDate1 = new Date(dis?.Discenddate?.replace(/-/g, "/"));
            const nexPaymentMonth = nexDate1?.toLocaleString("en-us", {
              month: "2-digit",
            });
            const nextPaymentDate = nexDate1?.toLocaleString("en-us", {
              day: "2-digit",
            });
            const nextPaymentYear = nexDate1?.getFullYear();
            let nextDueDate = `${nextPaymentYear}-${nexPaymentMonth}-${nextPaymentDate}`;
            const nexDate2 = new Date(dis?.Discfromdate?.replace(/-/g, "/"));
            const nexPaymentMonth1 = nexDate2?.toLocaleString("en-us", {
              month: "2-digit",
            });
            const nextPaymentDate1 = nexDate2?.toLocaleString("en-us", {
              day: "2-digit",
            });
            const nextPaymentYear1 = nexDate2?.getFullYear();
            let nextDueDate2 = `${nextPaymentYear1}-${nexPaymentMonth1}-${nextPaymentDate1}`;
            let loyaltyResult = false;
            const result = isSameOrBeforeDate(
              upcomingDates?.upcomingStartDueDate,
              nextDueDate,
            );
            loyaltyResult =
              dis?.Discfrequency?.toUpperCase() === "RECURRING" &&
              isDiscountApplicableAfterBillingDate(
                nextDueDate2,
                upcomingDates?.upcomingStartDueDate,
              );
            return result && !loyaltyResult && dis;
          });
          // Sum up their discount amounts
          const totalDiscountNew = bestDiscountsNew.reduce(
            (sum, d) => sum + (d.Discvalue ?? 0),
            0,
          );
          const discounts = bestDiscountsNew?.map((disc) => ({
            discount: disc?.Discvalue ? disc.Discvalue?.toFixed(2) : 0,
            discountName: disc?.Discdescription,
            Discfrequency: disc?.Discfrequency,
            validity: new Date(disc?.Discenddate).toLocaleString("en-US", {
              month: "numeric",
              day: "numeric",
              year: "numeric",
            }),
          }));
          item.discount = discounts;
          item.totalDiscount = totalDiscountNew?.toFixed(2);
        }
      }
      if (
        item?.discount &&
        Array.isArray(item?.discount) &&
        item?.discount?.length > 0 &&
        compareString(item?.additionalPlanName, "Whole")
      ) {
        additionalExtenderDiscount =
          item?.discount.find((d) =>
            d.discountName
              ?.toLowerCase()
              .includes("additional wifi extender".toLowerCase()),
          ) || 0;
        item.discount = item.discount.filter(
          (d) =>
            !d.discountName
              ?.toLowerCase()
              .includes("additional wifi extender".toLowerCase()),
        );
      }
      if (
        compareString(item.additionalPlanName, "Additional WiFi Extender") &&
        typeof additionalExtenderDiscount === "object" &&
        additionalExtenderDiscount
      ) {
        item.discount = [additionalExtenderDiscount];
        item.totalDiscount = Number(item.discount?.[0]?.discount) || 0;
      }
      return item;
    });
  }

  if (_data?.additionalPlans && Array.isArray(_data?.additionalPlans)) {
    _data.standardPlans.forEach((item) => {
      if (item.activetoDiscountsSet) {
        hasDisc.push({
          productName: item.productName,
          ...item.activetoDiscountsSet[0],
        });
      }
    });

    if (hasDisc && Array.isArray(hasDisc)) {
      _data.additionalPlans = _data.additionalPlans.map((item) => {
        if (compareString(item.additionalPlanName, "whole")) {
          item.discount = hasDisc.filter((diz) => {
            return compareString(diz.productName, "whole");
          });
        }

        if (compareString(item.additionalPlanName, "tech")) {
          item.discount = hasDisc.filter((diz) => {
            return compareString(diz.productName, "tech");
          });
        }
        if (compareString(item.additionalPlanName, "protection")) {
          item.discount = hasDisc.filter((diz) => {
            return compareString(diz.productName, "protection");
          });
        }

        if (_data?.discountPlans && Array.isArray(_data?.discountPlans)) {
          _data.discountPlans?.map((d) => {
            if (compareString(d.productName, item.ratePlanName)) {
              item.discount = [d];
            }
          });
        }
        return item;
      });
    }
  }

  // removing this from additional plan if there
  if (
    isGrandFather &&
    _data?.additionalPlans &&
    Array.isArray(_data?.additionalPlans)
  ) {
    _data.additionalPlans = _data.additionalPlans.filter((item) => {
      return (
        !compareString(item?.ratePlanName, "protection") ||
        !compareString(item?.ratePlanName, "controls")
      );
    });
  }

  // sorting data
  _data?.additionalPlans?.sort((a, b) => {
    const order = [
      "fiber",
      "mbps",
      "voice",
      "whole home",
      "whwifi",
      "extender",
      "protection",
      "internet controls",
      "tech",
    ];
    const aIndex = order.findIndex((key) =>
      a?.ratePlanName?.toLowerCase().includes(key),
    );
    const bIndex = order.findIndex((key) =>
      b?.ratePlanName?.toLowerCase().includes(key),
    );
    return (
      (aIndex === -1 ? Infinity : aIndex) - (bIndex === -1 ? Infinity : bIndex)
    );
  });
  return _data;
};

export function hasMismatch(cart, plans, taxSupport = false) {
  const hasKeyword = (items, keyword) =>
    items
      ? items?.some?.((item) =>
          item.productName
            ?.toLowerCase()
            .trim()
            .includes(keyword.toLowerCase()),
        ) || false
      : false;

  const includesKeyword = (items, keyword) =>
    items
      ? items?.some?.((item) =>
          item.productName?.toLowerCase().includes(keyword.toLowerCase()),
        ) || false
      : false;

  const extractSpeed = (str) => {
    const match = str?.match(/(\d+)/); // Extract only the number
    return match ? parseInt(match[1], 10) : null; // Return the number only
  };

  const cartHasSupport = hasKeyword(cart?.lineItems, "support");
  const planHasSupport = hasKeyword(plans?.additionalPlans || [], "support");

  // for wifi extender
  const cartHasWifiExt = hasKeyword(cart?.lineItems, "WiFi Extender");
  const planHasWExt = hasKeyword(plans?.additionalPlans, "WiFi Extender");

  const cartHasWholeWifi = hasKeyword(cart?.lineItems, "Whole Home");
  const planHasWholeWifi = hasKeyword(plans?.additionalPlans, "Whole Home");

  if (
    cart?.lineItems &&
    Array.isArray(cart?.lineItems) &&
    cart?.lineItems.length === 0
  ) {
    // alert("le empty")
    return false;
  }
  // SUPPORT (ignore if taxSupport is true)
  if (!taxSupport) {
    // If the cart has support but the plan does not, return true
    if (cartHasSupport && !planHasSupport) return true;
  }

  // CONTROLS - adjusted logic
  const cartHasControls =
    hasKeyword(cart?.lineItems, "controls") ||
    hasKeyword(cart?.lineItems, "protection");
  const planHasControls =
    hasKeyword(plans?.additionalPlans, "controls") ||
    hasKeyword(plans?.additionalPlans, "protection");
  const cartRemoveControl = cart?.lineItems?.some(
    (item) =>
      item.itemActionType?.toLowerCase() === "remove" &&
      item.productName?.toLowerCase().includes("controls"),
  );
  const cartRemoveTHTS = cart?.lineItems?.some(
    (item) =>
      item.itemActionType?.toLowerCase() === "remove" &&
      item.productName?.toLowerCase().includes("support"),
  );

  // If the cart contains 'controls' with actionType 'remove' or cart has controls but plan doesn't, return true
  if (cartRemoveControl || (cartHasControls && !planHasControls)) return true;
  if (cartRemoveTHTS || (cartHasSupport && !planHasSupport)) return true;
  if (cartHasWifiExt) return true;
  if (cartHasWholeWifi) return true;

  // VOICE - adjusted logic
  const cartHasVoice = includesKeyword(cart?.lineItems, "voice");
  const planHasVoice = includesKeyword(plans?.standardPlans, "voice");
  const cartRemoveVoice = cart?.lineItems?.some(
    (item) =>
      item.itemActionType?.toLowerCase() === "remove" &&
      item.productName?.toLowerCase().includes("voice"),
  );

  // If the cart contains 'voice' with actionType 'remove' or cart has voice but plan doesn't, return true
  if (cartRemoveVoice || (cartHasVoice && !planHasVoice)) return true;

  // FIBER SPEED (compare only numbers, no unit comparison)
  const cartFiberItem = cart?.lineItems?.find(
    (item) =>
      item.productName?.toLowerCase().includes("fiber") ||
      item.productName?.toLowerCase().includes("brightspeed now"),
  );
  const planFiberItem = plans?.standardPlans?.find(
    (plan) =>
      plan.planName?.toLowerCase()?.includes("fiber") ||
      plan.planName?.toLowerCase()?.includes("brightspeed now") ||
      plan.productName?.toLowerCase()?.includes("brightspeed now"),
  );
  const cartSpeed = extractSpeed(cartFiberItem?.productName);
  const planSpeed = extractSpeed(planFiberItem?.planName);

  // If the numbers don't match
  if (cartSpeed !== planSpeed) {
    return true; // Mismatch if the speeds are different
  }

  // If no mismatches
  return false;
}

export const isConsentChanged = (prev, current) => {
  if (prev.length !== current.length) return true; // different lengths means changed = true
  for (let i = 0; i < prev.length; i++) {
    if (prev[i] !== current[i]) return true; // any element mismatch means changed = true
  }
  return false; // arrays are exactly the same, so false
};

export const formatText = (input) => {
  const elements = [];
  let lastIndex = 0;

  // Match tags like <BOLD>text</BOLD> or <LINK href='url'>text</LINK>
  const regex = /<(\w+)(\s+[^>]*)?>(.*?)<\/\1>/g;
  let match;

  while ((match = regex.exec(input)) !== null) {
    const [fullMatch, tag, attrs = "", content] = match;

    // Push plain text before the match
    if (match.index > lastIndex) {
      elements.push(input.slice(lastIndex, match.index));
    }

    let element;
    const key = match.index;

    switch (tag.toUpperCase()) {
      case "BOLD":
        element = <b key={key}>{content}</b>;
        break;
      case "ITALIC":
        element = <i key={key}>{content}</i>;
        break;
      case "UNDERLINE":
        element = <u key={key}>{content}</u>;
        break;
      case "LINK": {
        const hrefMatch = attrs.match(/href=['"]([^'"]+)['"]/);
        const ariaLabel = attrs.match(/aria-label=['"]([^'"]+)['"]/);
        const href = hrefMatch ? hrefMatch[1] : "#";
        const ariaLabels = ariaLabel ? ariaLabel[1] : "#";
        element = (
          <a
            key={key}
            aria-label={ariaLabels}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
          >
            {content}
          </a>
        );
        break;
      }
      default:
        element = fullMatch; // Fallback
    }

    elements.push(element);
    lastIndex = regex.lastIndex;
  }

  // Add remaining text
  if (lastIndex < input.length) {
    elements.push(input.slice(lastIndex));
  }
  return elements;
};

export const getIWGIdentifier = (searchParams) => {
  const isSuspendFromUrl = searchParams.has("suspendnonpay");
  const isVacationFromUrl = searchParams.has("vacationpause");
  if (isSuspendFromUrl) {
    localStorage.setItem("isSuspendNonpay", "true");
    DwLogutil({
      stepName: EC_DW_LOGGING_STEPS.wg_np_stepped_in_acct_mgmt,
    });
  } else if (isVacationFromUrl) {
    localStorage.setItem("isVacationPause", "true");
    DwLogutil({
      stepName: EC_DW_LOGGING_STEPS.wg_vac_stepped_in_acct_mgmt,
    });
  }
};

export const getProdCode = (internet, cuurent_plan) => {
  let code = null;
  cuurent_plan.forEach((item) => {
    internet.map((internet_data) => {
      if (
        internet_data.offerResponse.offerDetails.billingProductId ==
        item.productId
      ) {
        code = internet_data.offerResponse.offerDetails.productCode;
      }
    });
  });
  return code;
};

/**
*
*
*
1. Move package  1 -> 2  =  Delete package 1and Add package 2 DONE
2. Move package  1 -> 3  =  Delete package 1and Add package 2, package 3 DONE
3. Move package  1-> 0   =  Delete package 1 DONE
4. Move package  2 -> 1  =  Delete package 2 and add package 1 DONE
5. Move package  2 -> 0  =  Delete package 2. DONE
6. Move package  2 ->  3 =  Add package 3 only DONE
7. Move package  3 -> 2  =  Delete package 3 only DONE
8. Move package  3 -> 1  =  Delete package 3, package 2 and add package 1 DONE
9. Move package  3 -> 0  =  Delete package 3, delete package 2. DONE}  
* @param {*} whwCount
*/
export const getWHWCartLineItemPostpaid = (
  isPrepaid,
  isCreateCart,
  parentVasCode,
  WHWProductCodeArray,
  extQty,
  whwCount,
) => {
  localStorage.removeItem("downgradeWifi");
  // const WHWProductCodeArray = ["WHWProductCode", "WHW2ProductCode", "WHW3ProductCode"];
  let lineItem = [];
  // For add Upgrade package
  if (extQty < whwCount) {
    for (var i = extQty; i < whwCount; i++) {
      if (isPrepaid === true) {
        lineItem.push({
          action: "addLineItem",
          productId: WHWProductCodeArray[i],
          quantity: 1,
        });
      } else {
        lineItem.push({
          action: "addAddOns",
          productId: parentVasCode,
          features: [WHWProductCodeArray[i]],
          addOns: [WHWProductCodeArray[i]],
          addOnParentPricePlans: [parentVasCode],
          quantity: 1,
        });
      }
    }
    if (extQty === 1) {
      if (isPrepaid === true) {
        localStorage.setItem("downgradeWifi", "DOWN");
        lineItem.push({
          quantity: 1,
          action: "removeLineItem",
          // itemActionType: "remove",
          ...(isCreateCart
            ? { productId: WHWProductCodeArray[0] }
            : { lineItemId: WHWProductCodeArray[0] }),
        });
      } else {
        lineItem.push({
          itemActionType: "delete",
          case: "exsiting quantity 1 postpaid",
          productId: parentVasCode,
          features: [WHWProductCodeArray[0]],
          addOns: [WHWProductCodeArray[0]],
          addOnParentPricePlans: [parentVasCode],
          quantity: 1,
          type: "addons",
          action: "addAddOns",
        });
      }
    }
  }
  if (whwCount < extQty) {
    for (var i = extQty; i > whwCount; i--) {
      if (isPrepaid === true) {
        localStorage.setItem("downgradeWifi", "DOWN");
        lineItem.push({
          quantity: 1,
          action: "removeLineItem",
          // itemActionType: "remove",
          ...(isCreateCart
            ? { productId: WHWProductCodeArray[i - 1] }
            : { lineItemId: WHWProductCodeArray[i - 1] }),
        });
      } else {
        lineItem.push({
          itemActionType: "delete",
          productId: parentVasCode,
          features: [WHWProductCodeArray[i - 1]],
          addOns: [WHWProductCodeArray[i - 1]],
          addOnParentPricePlans: [parentVasCode],
          quantity: 1,
          type: "addons",
          action: "addAddOns",
        });
      }
    }
    if (whwCount === 1) {
      if (isPrepaid === true) {
        lineItem.push({
          action: "addLineItem",
          productId: WHWProductCodeArray[0],
          quantity: 1,
        });
      } else {
        lineItem.push({
          action: "addAddOns",
          productId: parentVasCode,
          features: [WHWProductCodeArray[0]],
          addOns: [WHWProductCodeArray[0]],
          addOnParentPricePlans: [parentVasCode],
          quantity: 1,
        });
      }
    }
    /**
     * if user has 2 or 3 WHW then no need to delete package 1 whw
     */

    if (whwCount == 0 && extQty >= 2) {
      if (isPrepaid === true) {
        if (isCreateCart) {
          lineItem = lineItem.filter(
            (item) => item.productId !== WHWProductCodeArray[0],
          );
        } else {
          lineItem = lineItem.filter(
            (item) => item.lineItemId !== WHWProductCodeArray[0],
          );
        }
      } else {
        lineItem = lineItem.filter(
          (item) => item.features[0] !== WHWProductCodeArray[0],
        );
      }
    }
  }
  return lineItem;
};

/**
 * Env-controlled retry / loop guards for Redux API thunks.
 * REACT_APP_API_RETRY_GUARD_ENABLED — "true" enables caps and fetched-out blocking; "false" disables them.
 * REACT_APP_API_MAX_RETRY_COUNT — failures before auto-retry stops (default 3).
 */
const parseRetryGuardEnabled = () => {
  const value = process.env.REACT_APP_API_RETRY_GUARD_ENABLED;
  if (value === undefined || value === "") {
    return true;
  }
  return value.toLowerCase() === "true";
};

const parseMaxRetryCount = () => {
  const parsed = Number(process.env.REACT_APP_API_MAX_RETRY_COUNT);
  if (!Number.isFinite(parsed) || parsed < 1) {
    return 3;
  }
  return parsed;
};

export const API_RETRY_GUARD_ENABLED = parseRetryGuardEnabled();
export const API_MAX_RETRY_COUNT = parseMaxRetryCount();

export const isApiRetryGuardEnabled = () => API_RETRY_GUARD_ENABLED;

export const getApiMaxRetryCount = () => API_MAX_RETRY_COUNT;

export const shouldStopApiRetry = (retryCount) =>
  isApiRetryGuardEnabled() && retryCount >= getApiMaxRetryCount();

export const shouldSkipFailedOutApiFetch = (hasData, fetched) =>
  isApiRetryGuardEnabled() && !hasData && fetched;

export const logApiRetryCapDwLog = (stepName, errorMessage) => {
  if (!stepName || !isApiRetryGuardEnabled()) {
    return;
  }
  const reduxStore = store.getState();
  const headers = reduxStore?.brightspeedToken?.headers;
  const sessionId =
    sessionStorage?.getItem("sessionId") || reduxStore?.user?.sessionId;
  const email = reduxStore?.user?.data?.email;
  const maxRetries = getApiMaxRetryCount();
  const error = errorMessage
    ? `${errorMessage} | max retries ${maxRetries}`
    : `max retries ${maxRetries} reached`;

  DwLogutil({
    headers,
    sessionId,
    email,
    stepName,
    error,
  });
};

/** Parse sessionId from URL (sessionId= or state=sessionId_{id}). */
export const getB2cSessionIdFromSearch = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  const directSessionId = params.get("sessionId")?.trim();
  if (directSessionId) return directSessionId;
  const state = params.get("state");
  if (!state?.startsWith("sessionId_")) return "";
  return state.split("_")[1]?.trim() || "";
};

/** sessionStorage → B2C URL → sessionid cookie. Writes to sessionStorage when found. */
export const resolveSessionId = (search = window.location.search) => {
  const stored = sessionStorage?.getItem("sessionId")?.trim();
  if (stored) return stored;

  const params = new URLSearchParams(search);
  if (params.has("code") || params.has("error")) {
    const fromUrl = getB2cSessionIdFromSearch(search);
    if (fromUrl) {
      sessionStorage.setItem("sessionId", fromUrl);
      return fromUrl;
    }
  }

  const cookieMatch = document.cookie?.match(/(?:^|;\s*)sessionid=([^;]*)/i);
  const fromCookie = cookieMatch?.[1]?.trim();
  if (fromCookie) {
    sessionStorage.setItem("sessionId", fromCookie);
    return fromCookie;
  }
  return "";
};

/** Sync sessionid cookie on B2C sign-in page load (latest from headers → user → storage → cookie → URL). */
export const syncB2cSessionIdCookie = (
  setCookie,
  headersSessionId,
  cookieSessionId,
  userSessionId,
) => {
  const latestSessionId =
    headersSessionId?.trim() ||
    userSessionId?.trim() ||
    sessionStorage?.getItem("sessionId")?.trim() ||
    cookieSessionId?.trim() ||
    resolveSessionId();
  if (!latestSessionId) return;

  const onBrightspeedHost =
    window.location.hostname.includes("brightspeed.com");
  setCookie("sessionid", latestSessionId, {
    path: "/",
    ...(onBrightspeedHost && { domain: ".brightspeed.com" }),
    secure: onBrightspeedHost || window.location.protocol === "https:",
    sameSite: "lax",
  });
};

/** Returns the Optimizely Web project key from env (set per build via .env*). */
export const OPTIMIZELY_PROJECT_KEY = () =>
  process.env.REACT_APP_OPTIMIZELY_PROJECT_KEY;

export const isEmptyObject = (obj) => !(obj && Object.keys(obj).length > 0);

export const checkHasObject = (obj) => {
  return obj !== null && obj !== undefined && !isEmptyObject(obj);
};

export const checkWifiExtenderAppliedToProduct = (
  additionalPlan,
  servicedetail,
) => {
  let HAS_WIFI_EXT =
    additionalPlan?.length &&
    additionalPlan?.find(
      (element) =>
        (compareString(element?.ratePlanName, "wifi extender") ||
          compareString(element?.additionalPlanName, "wifi extender")) &&
        (!compareString(element?.ratePlanName, "additional") ||
          !compareString(element?.additionalPlanName, "additional")),
    );
  return HAS_WIFI_EXT ? true : false;
};

export const checkProtectionPlanAppliedToProduct = (
  additionalPlan,
  servicedetail,
) => {
  const isGrandFather = store.getState()?.customerInfo?.isGrandFather;

  let hasInservice =
    servicedetail?.subscriptions &&
    Array.isArray(servicedetail?.subscriptions) &&
    servicedetail?.subscriptions?.length > 0 &&
    servicedetail?.subscriptions[0]?.serviceDetails &&
    Array.isArray(servicedetail?.subscriptions[0]?.serviceDetails) &&
    servicedetail?.subscriptions[0]?.serviceDetails.find((ele) =>
      compareString(ele.serviceName, "protection"),
    );

  let IQ_BUNDLE = !isGrandFather
    ? additionalPlan?.length &&
      additionalPlan?.find(
        (element) =>
          compareString(element?.ratePlanName, "controls") ||
          compareString(element?.ratePlanName, "protection") ||
          compareString(element?.additionalPlanName, "controls") ||
          compareString(element?.additionalPlanName, "protection"),
      )
    : false;
  return hasInservice || IQ_BUNDLE ? true : false;
};

export const checkTHTSAppliedToProduct = (additionalPlan, servicedetail) => {
  let HAS_THTS = additionalPlan?.find((element) =>
    compareString(element?.ratePlanName, "home tech support"),
  );

  let hasInservice =
    servicedetail?.subscriptions &&
    Array.isArray(servicedetail?.subscriptions) &&
    servicedetail?.subscriptions?.length > 0 &&
    servicedetail?.subscriptions[0]?.serviceDetails &&
    Array.isArray(servicedetail?.subscriptions[0]?.serviceDetails) &&
    servicedetail?.subscriptions[0]?.serviceDetails.find((ele) =>
      compareString(ele.serviceName, "total home"),
    );

  return hasInservice || HAS_THTS ? true : false;
};

export const checkWholeHomeAdded = (additionalPlan, servicedetail) => {
  let HAS_THTS = additionalPlan?.find((element) =>
    compareString(element?.ratePlanName, "whole"),
  );

  let hasInservice =
    servicedetail?.subscriptions &&
    Array.isArray(servicedetail?.subscriptions) &&
    servicedetail?.subscriptions?.length > 0 &&
    servicedetail?.subscriptions[0]?.serviceDetails &&
    Array.isArray(servicedetail?.subscriptions[0]?.serviceDetails) &&
    servicedetail?.subscriptions[0]?.serviceDetails.find((ele) =>
      compareString(ele.serviceName, "whole"),
    );

  return hasInservice || HAS_THTS ? true : false;
};

export const isEligibleForPromoOffer = (
  productKeyword,
  subScriptionPlanDetails,
  addonProduct,
) => {
  try {
    // Check if the offer is available in the catalog first

    if (checkHasObject(addonProduct) && addonProduct?.hasOneMonth !== true) {
      return false;
    }

    if (!productKeyword || !subScriptionPlanDetails) {
      return false;
    }

    // Get expired VAS discount plans (both Zuora and BRIM)

    const expiredDiscountPlans = getExpiredVasDiscountPlans(
      subScriptionPlanDetails,
    );

    // If no expired discount plans found, user is eligible

    if (
      !Array.isArray(expiredDiscountPlans) ||
      expiredDiscountPlans.length === 0
    ) {
      return true;
    }

    const productKeywordLower = productKeyword?.toLowerCase();

    const promoCodePatterns = ["1MF"]; // 1 Month Free and 3 Months Free

    // Find all promotional offers for the specified product from expired plans

    const productPromoOffers = expiredDiscountPlans.filter((item) => {
      const planName =
        `${item?.planName || ""} ${item?.ratePlanName || ""} ${item?.productName || ""} ${item?.Discdescription || ""}`.toLowerCase();

      const discCode = (item?.Disccode || item?.discCode || "")?.toUpperCase();

      // Check if this discount is related to the product

      const isProductMatch = planName.includes(productKeywordLower);

      // Check if this is a promotional offer (1MF or 3MF)

      const isPromoOffer =
        promoCodePatterns.some((pattern) => discCode.includes(pattern)) ||
        planName.includes("month free") ||
        planName.includes("months free");

      return isProductMatch && isPromoOffer;
    });

    // If no promotional offers found for this product, user is eligible

    if (productPromoOffers.length === 0) {
      return true;
    }

    // Check the most recent promo offer end date

    const twelveMonthsAgo = moment().subtract(12, "months").startOf("day");

    // Find the most recent promo offer end date

    let mostRecentEndDate = null;

    for (const offer of productPromoOffers) {
      const endDateRaw = getExpiredDiscountEndDate(offer);

      const endDate = endDateRaw ? moment(parseDiscountDate(endDateRaw)) : null;

      if (
        endDate &&
        endDate.isValid() &&
        (!mostRecentEndDate || endDate.isAfter(mostRecentEndDate))
      ) {
        mostRecentEndDate = endDate;
      }
    }

    // If no valid end date found, assume eligible

    if (!mostRecentEndDate || !mostRecentEndDate.isValid()) {
      return true;
    }

    // User is eligible if the most recent promo offer expired MORE than 12 months ago

    // User is NOT eligible if the promo offer expired within the last 12 months

    const isExpiredMoreThan12MonthsAgo =
      mostRecentEndDate.isBefore(twelveMonthsAgo);

    return isExpiredMoreThan12MonthsAgo;
  } catch (error) {
    return true; // Default to eligible on error
  }
};

const getExpiredVasDiscountPlans = (subScriptionPlanDetails) => {
  // For Prepaid (Zuora) users
  const expiredZuoraPlans =
    subScriptionPlanDetails?.expiredZuoraVasDiscountPlans || [];

  // For Postpaid (BRIM) users
  const expiredBrimPlans =
    subScriptionPlanDetails?.expiredBrimVasDiscountsSet || [];

  // Combine both arrays
  return [...expiredZuoraPlans, ...expiredBrimPlans];
};

const getExpiredDiscountEndDate = (discount) => {
  return (
    discount?.effectiveEndDate || // Zuora format
    discount?.Discenddate || // BRIM format
    null
  );
};

export const parseDiscountDate = (rawDate) => {
  if (!rawDate) return null;
  const asString = String(rawDate).trim();
  if (!asString) return null;

  // Supports both "YYYY-MM-DD" and "MM.DD.YYYY" date formats from discount payloads.
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(asString)) {
    const [month, day, year] = asString.split(".");
    const dotDate = new Date(`${year}/${month}/${day}`);
    return Number.isNaN(dotDate.getTime()) ? null : dotDate;
  }

  const parsedDate = new Date(asString.replace(/[-.]/g, "/"));
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};
